import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 30, className = "" }) {
    return <div className={className}>{children}</div>;
}

export function MaskLine({ children, delay = 0, className = "" }) {
    return (
        <span className={`block overflow-hidden ${className}`}>
            <motion.span
                className="block will-change-transform"
                initial={{ y: "112%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.9, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function SectionHead({ eyebrow, title, hindi, dark = false, className = "" }) {
    return (
        <div className={className}>
            <p className="eyebrow">{eyebrow}</p>
            <h2
                className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight leading-[1.05] ${
                    dark ? "text-paper" : "text-ink"
                }`}
            >
                {title}
            </h2>
            {hindi && (
                <p className={`mt-3 font-hindi text-base ${dark ? "text-paper/70" : "text-steel"}`}>
                    {hindi}
                </p>
            )}
        </div>
    );
}
